import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import SignInPage from "./pages/SignIn";
import SignUpPage from "./pages/SignUp";
import Dashboard from "./pages/Dashboard";
import CreateTournament from "./pages/tournament/CreateTournament";
import TournamentDetailsPage from "./pages/tournament/TournamentDetailsPage";
import CreateTeam from "./pages/teams/CreateTeam";
import TeamPage from "./pages/teams/TeamPage";
import TeamDetailsPage from "./pages/teams/TeamDetailsPage";
import CreateRosterForm from "./pages/rosters/CreateRoster";
import CreateRosterPlayerForm from "./pages/rosters/CreatePlayer";
import Profile from "./pages/user/Profile";
import CategoryUser from "./pages/user/CategoryUser";
import OrganizationProfile from "./pages/user/OrganizationProfile";
import ProfileOrganizationImg from "./pages/user/ProfileOrganizationImg";
import PlayerProfile from "./pages/user/PlayerProfile";
import BottomNavBar from "./components/BottomNavBar";
import Create from "./pages/Create";
import MyTournaments from "./pages/tournament/MyTournaments";
import MyTeams from "./pages/teams/MyTeams";
import ToastNotification from "./components/ToastNotification";
import TablaPosiciones from "./pages/mundialito/tablas";
import ProtectedRoute from "./components/ProtectedRoute";
import Invernal from "./pages/mundialito/invernal";
import { Analytics } from "@vercel/analytics/react";
import ForgotPassword from "./pages/user/password/ForgotPassword";
import RecoverPassword from "./pages/user/password/RecoverPass";
import PublicTournaments from "./pages/tournament/PublicTournaments";
import PlayerDetailsPage from "./pages/players/PlayerDetailsPage";

export default function App() {
  return (
    <BrowserRouter>
      <ToastNotification />
      <div className="pb-12">
        {" "}
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/signin" element={<SignInPage />} />
          <Route path="/signup" element={<SignUpPage />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/recover-password" element={<RecoverPassword />} />
          <Route
            path="/profile"
            element={<ProtectedRoute element={<Profile />} />}
          />
          <Route
            path="/category-user"
            element={<ProtectedRoute element={<CategoryUser />} />}
          />
          <Route
            path="/orgnization-profile"
            element={<ProtectedRoute element={<OrganizationProfile />} />}
          />
          <Route
            path="/organization-profile-img"
            element={<ProtectedRoute element={<ProfileOrganizationImg />} />}
          />
          <Route
            path="/my-tournaments"
            element={<ProtectedRoute element={<MyTournaments />} />}
          />
          <Route
            path="/my-teams"
            element={<ProtectedRoute element={<MyTeams />} />}
          />
          <Route
            path="/player-profile"
            element={<ProtectedRoute element={<PlayerProfile />} />}
          />
          <Route path="/create" element={<Create />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route
            path="/create-tournament"
            element={<ProtectedRoute element={<CreateTournament />} />}
          />
          <Route path="/tournaments" element={<PublicTournaments />} />
          <Route path="/tournaments/:id" element={<TournamentDetailsPage />} />
          <Route
            path="/create-team"
            element={<ProtectedRoute element={<CreateTeam />} />}
          />
          <Route path="/teams" element={<TeamPage />} />
          <Route path="/teams/:id" element={<TeamDetailsPage />} />

          <Route path="/players/:id" element={<PlayerDetailsPage />} />
          <Route path="/create-roster-form" element={<CreateRosterForm />} />
          <Route
            path="/create-roster-player"
            element={<CreateRosterPlayerForm />}
          />
          <Route path="/mundialito-kids" element={<TablaPosiciones />} />
          <Route path="/torneo-invernal" element={<Invernal />} />
          <Route path="*" element={<h1>Not Found</h1>} />
        </Routes>
      </div>
      <BottomNavBar />
      <Analytics />
    </BrowserRouter>
  );
}
